export default "<p>services works!</p>\n"